/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalFireDepartmentIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-fire-department"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.67 14Q3.67 11.18 5.36 8.5Q7.05 5.83 10.03 3.8Q10.75 3.3 11.54 3.75Q12.32 4.2 12.32 5.13L12.32 6.3Q12.32 7 12.81 7.49Q13.3 7.97 14.03 7.97Q14.38 7.97 14.71 7.81Q15.05 7.65 15.3 7.35Q15.57 7.03 15.96 6.94Q16.35 6.85 16.68 7.08Q18.38 8.3 19.35 10.14Q20.32 11.97 20.32 14Q20.32 16.27 19.23 18.14Q18.13 20 16.32 21.1Q16.8 20.45 17.06 19.68Q17.32 18.9 17.32 18.05Q17.32 17 16.93 16.04Q16.52 15.07 15.78 14.32L12 10.65L8.25 14.32Q7.47 15.07 7.08 16.02Q6.67 16.98 6.67 18.05Q6.67 18.9 6.94 19.68Q7.2 20.45 7.67 21.1Q5.88 20 4.78 18.14Q3.67 16.27 3.67 14ZM12 14.35L13.9 16.23Q14.28 16.6 14.47 17.06Q14.68 17.52 14.68 18.05Q14.68 19.15 13.9 19.91Q13.13 20.68 12 20.68Q10.88 20.68 10.1 19.91Q9.32 19.15 9.32 18.05Q9.32 17.52 9.53 17.06Q9.72 16.6 10.1 16.23Z" fill={color} />
    </svg>
  );
}
